import { useQuery } from "@apollo/client";
import { QUERY_SEDES } from "../graphql/queries";

export const useSites = () => {
  const { data, loading } = useQuery(QUERY_SEDES);
  return { data, loading };
};
